import React from 'react';
import Typography from '@mui/material/Typography';

//處理以下格式的網址：[url](url)、[txt](url)、txt:url、txt+url、url+標點符號、 txt+url(前面有空格)
const parseLinks = (text) => {
  const urlRegex = /(\[([^\]]+)\]\(([^)]+)\))|((https?:\/\/[^\s]+))/g;
  const parts = [];
  let lastIndex = 0;

  text.replace(urlRegex, (match, _, linkText, url, __, plainUrl, offset) => {
    if (offset > lastIndex) {
      parts.push({ isLink: false, text: text.slice(lastIndex, offset) });
    }

    if (linkText && url) {
      // Markdown-style link
      parts.push({ isLink: true, text: url, linkText: linkText });
    } else if (plainUrl) {
      // Plain URL
      let cleanUrl = plainUrl.replace(/\/?[。，、！？：；]$/, '');
      parts.push({ isLink: true, text: cleanUrl });
    }

    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < text.length) {
    parts.push({ isLink: false, text: text.slice(lastIndex) });
  }

  return parts;
};


const Linkify = ({ text, textStyle }) => {
  const parts = parseLinks(text);

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {!part.isLink ? (
            <Typography style={textStyle}>
              {part.text}
            </Typography>
          ) : (
            <>
              <Typography
                component="a"
                href={part.text}
                target="_blank"
                rel="noopener noreferrer"
                style={{ ...textStyle, textDecoration: 'underline', color: 'blue' }}
              >
                {part.linkText || part.text}
              </Typography>
              <br /><br />
            </>
          )}
        </React.Fragment>
      ))}
    </>
  );
}

export default Linkify;